import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

interface PresenceEntry {
	online: boolean;
	last_seen_at?: string;
}

interface PresenceState {
	users: Record<string, PresenceEntry>;
}

const initialState: PresenceState = {
	users: {},
};

export const presenceSlice = createSlice({
	name: "presence",
	initialState,
	reducers: {
		setPresenceUsers: (state, { payload }: PayloadAction<string[]>) => {
			const next: Record<string, PresenceEntry> = {};
			for (const userId of payload) {
				next[userId] = { online: true };
			}
			state.users = next;
		},
		markUserOnline: (state, { payload }: PayloadAction<string>) => {
			state.users[payload] = { online: true };
		},
		markUserOffline: (state, { payload }: PayloadAction<string>) => {
			state.users[payload] = { online: false, last_seen_at: new Date().toISOString() };
		},
		clearPresence: (state) => {
			state.users = {};
		},
	},
});

export const { setPresenceUsers, markUserOnline, markUserOffline, clearPresence } = presenceSlice.actions;
